module.exports = __webpack_public_path__ + "static/media/Cabinet_Before.24d637af.jpg";